export default {
  install(Vue, options) {
    const { store } = options;

    Vue.prototype.$alertSuccess = message => {
      store.dispatch('alerts/openSuccess', message);
    };

    Vue.prototype.$alertError = message => {
      store.dispatch('alerts/openError', message);
    };

    Vue.prototype.$alertWarning = message => {
      store.dispatch('alerts/openWarning', message);
    };
  },
};
